import { render } from "./FooterStyleTwo.vue?vue&type=template&id=0bfa61c8"
import script from "./FooterStyleTwo.vue?vue&type=script&lang=js"
export * from "./FooterStyleTwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__